import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'navigation-shortcuts.add-repository-modal.flags.failure.title',
		defaultMessage: 'Sorry! You were unable to add this repository',
		description: '',
	},
	description: {
		id: 'navigation-shortcuts.add-repository-modal.flags.failure.description',
		defaultMessage: 'Please try again later',
		description: '',
	},
});
